import React from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import InfoIcon from '@mui/icons-material/Info';

const RelatedTeacher = () => {
  const [teachers, setTeachers] = useState([]);
  const [price, setPrice] = useState(0); // State to track the selected price

  useEffect(() => {
    axios
      .get("https://topfaculty.co.in/api/teacher-list2.php")
      .then((response) => {
         setTeachers(response.data);
      })
      .catch((error) => {
        console.log("Error Fetching Data", error);
      });
  }, []);

  return (
    <>
      <div className="rs-courses-details mt-4">
        <div className="container">
          <div className="row ">
            <h3 style={{ fontWeight: "600",fontSize: "23px" }} class="instructor-title">
              Our Related <span class="primary-color">TEACHERS </span>
            </h3>

            {teachers.map((teacher, index) => {
              // Ensure videoLink is parsed into an actual array
              let videoLinks = [];
              if (teacher.videoLink) {
                try {
                  videoLinks = JSON.parse(teacher.videoLink); // Parse the string into an array
                } catch (error) {
                  console.log("Error parsing video links:", error);
                }
              }

              let notesLink = [];
              if (teacher.notesLink) {
                try {
                  notesLink = JSON.parse(teacher.notesLink); // Parse the string into an array
                } catch (error) {
                  console.log("Error parsing Notes links:", error);
                }
              }

              return (
                <div className="col-lg-4 col-md-12">
                  <div
                    id="rs-latest-news"
                    className="rs-latest-news"
                    style={{padding:"2px"}}
                  >
                    <div
                      className="news-list-block"
                      style={{
                        boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                      }}
                    >
                      <div className="news-list-item">
                        <div className="news-content">
                          <h5 className="news-title">
                            <Link
                              to={`/teacher/${teacher.TeacherId}/${teacher.TeacherName}`}
                              state={{ scrollToSection: true }}
                            >
                              <i
                                class="fa fa-male primary-color"
                                aria-hidden="true"
                              ></i>
                              &nbsp;
                              {teacher.TeacherName}
                            </Link>
                          </h5>
                          <div className="news-date">
                            <i className="fa fa-calendar-check-o" />
                            <span title={teacher.TeacherEmail}>
                              {teacher.TeacherEmail.length > 15
                                ? teacher.TeacherEmail.substring(0, 15) + "..."
                                : teacher.TeacherEmail}
                            </span>
                          </div>

                          {/* <div
                            className="apply-btn"
                            style={{
                              height: "33px",
                              lineHeight: "33px",
                              minWidth: "95px",
                            }}
                          >
                            <Link
                              style={{ background: "rgb(9 11 89)" }}
                              to={`/teacher/${teacher.TeacherId}/${teacher.TeacherName}`}
                              state={{ scrollToSection: true }}>
                              Details
                            </Link>
                          </div> */}

                          <Link
                            to={`/teacher/${teacher.TeacherId}/${teacher.TeacherName}`}
                            state={{ scrollToSection: true }}
                          >
                            <Button
                              variant="contained"
                               size="small"
                              fontSize="inherit"
                              style={{ fontWeight: "700" }}
                            >
                              Details{" "}&nbsp;
                              <InfoIcon/>
                            </Button>
                          </Link>


                        </div>
                        <div
                          className="news-img"
                          style={{ paddingRight: "11%" }}
                        >
                          <a href="#">
                            <img
                              src={
                                teacher.TeacherProfile
                                  ? teacher.TeacherProfile
                                  : "https://i.pinimg.com/736x/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg"
                              }
                              // src= "https://i.pinimg.com/736x/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg"
                              alt=""
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default RelatedTeacher;
